import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function StudentLink({ element, onToggle, selectedIds }) {
  const isSelected = selectedIds ? selectedIds.has(element.id) : false;
  // A rush invoice (main or "another") paints the whole row yellow and
  // adds a badge, so the queues can spot them at a glance.
  const isRush = Number(element.rush) > 0 || Number(element.another_rush) > 0;
  const [date, setDate] = useState("");
  const pathname_one = useLocation().pathname.split("/")[2];
  const pathname_two = useLocation().pathname.split("/")[3];
  const navigate = useNavigate();

  const getDate = useCallback(() => {
    if (pathname_one === "auditing" && pathname_two === "new") {
      setDate(element.submit_date);
    } else if (pathname_one === "auditing" && pathname_two === "request_edit") {
      setDate(
        element.request_edit_date
          ? element.request_edit_date
          : element.submit_date,
      );
    } else if (pathname_one === "invoice" && pathname_two === "new") {
      setDate(element.invoice_date);
    } else if (pathname_one === "invoice" && pathname_two === "wait") {
      setDate(element.invoice_wait_date);
    } else if (
      pathname_one === "invoice" &&
      pathname_two === "another_invoice"
    ) {
      setDate(
        element.another_invoice_date
          ? element.another_invoice_date
          : element.invoice_date,
      );
    } else if (
      pathname_one === "score" &&
      pathname_two === "score_validation"
    ) {
      setDate(element.score_validation_date);
    } else if (pathname_one === "score" && pathname_two === "new") {
      setDate(element.score_request_date);
    } else if (pathname_one === "score" && pathname_two === "score_pending") {
      setDate(element.score_pending_date);
    } else if (pathname_one === "print" && pathname_two === "new") {
      setDate(element.print_date);
    } else if (
      pathname_one === "print" &&
      pathname_two === "print_validation"
    ) {
      setDate(element.print_validation_date);
    } else if (pathname_one === "moe" && pathname_two === "new") {
      setDate(element.moe_date);
    } else if (pathname_one === "deliver") {
      setDate(element.deliver_date);
    } else if (pathname_one === "mohe" && pathname_two === "mohe_validation") {
      setDate(element.mohe_validation_date);
    } else if (pathname_one === "mohe" && pathname_two === "new") {
      setDate(element.mohe_date);
    } else if (pathname_one === "done") {
      setDate(element.done_date);
    } else {
      setDate(element.submit_date);
    }
  }, [pathname_one, pathname_two, element]);

  useEffect(() => {
    getDate();
    // console.log(element);
  }, [getDate]);

  return (
    <div
      className={`w-full my-2 border py-2.5 px-5 rounded-lg
          flex flex-wrap items-center justify-between cursor-pointer text-sm font-medium
          ${
            isSelected
              ? "bg-blue-50 border-blue-300 hover:bg-blue-100"
              : isRush
                ? "bg-yellow-100 border-yellow-400 hover:bg-yellow-200"
                : "hover:bg-gray-50"
          }`}
      onClick={() => {
        if (!onToggle) {
          navigate(element.id.toString(), { state: element });
        }
      }}
    >
      {onToggle && (
        <div
          className="mr-3 flex-shrink-0"
          onClick={(e) => { e.stopPropagation(); onToggle(element.id); }}
        >
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => onToggle(element.id)}
            className="w-4 h-4 accent-blue-600 cursor-pointer"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
      <p
        className={`${onToggle ? "md:w-3/5 w-4/5" : "md:w-3/5 w-full"} cursor-pointer`}
        onClick={() => { if (!onToggle) return; navigate(element.id.toString(), { state: element }); }}
      >
        {element.full_name}
        {Number(element.shipping) > 0 && (
          <span className="bg-blue-600 text-white text-xs font-semibold ml-2 px-2 py-0.5 rounded-md align-middle">
            shipping
          </span>
        )}
        {isRush && (
          <span className="bg-yellow-400 text-yellow-900 text-xs font-semibold ml-2 px-2 py-0.5 rounded-md align-middle">
            rush
          </span>
        )}
      </p>
      {element.invoice_user ? (
        <p className="bg-lime-300 w-32 text-center p-1 rounded-lg">
          {element.invoice_user}
        </p>
      ) : (
        ""
      )}
      <p className="bg-lime-600 w-24 text-center p-1 rounded-lg">{date}</p>
    </div>
  );
}
